import titanicS from "../images/titanicScene.png";
import tita from "../images/tit.png";
import movieLogo from "../images/movieLogo.png";
import spidey from "../images/spidey.png";
import jumanji from "../images/jumanji.png";
import wolf from "../images/wolf.png";
import mrs from "../images/mrs.png";
import hob from "../images/hob.png";
import spideyLogo from "../images/spideyLogo.png";
import spideyScene from "../images/spideyScene.png";
import moralis from "../images/moralis.png";
import moralisLogo from "../images/moralisLogo.png";
import moralisScene from "../images/moralisScene.png";
import jam from "../images/jam.png";
import jamLogo from "../images/jamLogo.png";
import jamScene from "../images/jamScene.png";
import bayw from "../images/bayw.png";
import shrek from "../images/shrek.png";
import lucy from "../images/lucy.png";
import topgu from "../images/topgu.png";
import imit from "../images/imit.png";
import reven from "../images/reven.png";
import tomb from "../images/tomb.png";
import amaz from "../images/amaz.png";
import bigs from "../images/bigs.png";
import secona from "../images/secona.png";
import ted from "../images/ted.png";
import amerp from "../images/amerp.png";

export const movies = [
  {
    Movie: "",
    Thumnbnail: tita,
    Scene: titanicS,
    Logo: movieLogo,
    Name: "Titanic",
    Description:
      "Staring Kate Winslet and Leonardo DiCaprio. The two play characters who are of different social classes. They fall in love after meeting aboard the ship, but it was not good for a rich girl to fall in love with a poor boy in 1912.",
    Genre: "Romance, Drama",
    Actors: "Kate Winslet, Leonardo DiCaprio",
    Year: "1998",
    Duration: "3h 14min",
  },
  {
    Movie: "https://ipfs.moralis.io:2053/ipfs/QmNtxfy9Mk8qLsdGnraHGk5XDim8ayR93krM24ETJEd2bG/media/0",
    Thumnbnail: spidey,
    Scene: spideyScene,
    Logo: spideyLogo,
    Name: "Spiderman Homecoming",
    Description: "Peter Parker tries to stop the Vulture from selling weapons made with advanced Chitauri technology while trying to balance his life as an ordinary high school student.",
    Genre: "Action, Superhero, Comedy",
    Actors: "Tom Holland, Zendeya",
    Year: "2017",
    Duration: "2h 13min",
  },
  {
    Movie: "",
    Thumnbnail: jumanji,
    Scene: "",
    Logo: "",
    Name: "Jumanji",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "https://ipfs.moralis.io:2053/ipfs/QmWWnyCZwh8RVnamjeLhGmpYM2C3oDr3FzF7zgv5ur24z5/media/0",
    Thumnbnail: moralis,
    Scene: moralisScene,
    Logo: moralisLogo,
    Name: "Moralis Rap",
    Description: "Moralis serverless Web3 Dapps, is a beautiful music video that tells a touching story of how anyone can become a Web3 developer if they put their trust in the hands of the musically gifted team at Moralis. ",
    Genre: "Music Video",
    Actors: "Ivan Liljeqvist, Filip Martinsson, CTO Larsson",
    Year: "2021",
    Duration: "1min 2sec",
  },
  {
    Movie: "",
    Thumnbnail: wolf,
    Scene: "",
    Logo: "",
    Name: "Wolf Of Wallstreet",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: mrs,
    Scene: "",
    Logo: "",
    Name: "Mr and Mrs Smith",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "https://ipfs.moralis.io:2053/ipfs/QmSi84pJTjBXmXREN8NMRuRnK9oobYb8QcPZsXUj3GZr12/media/0",
    Thumnbnail: jam,
    Scene: jamScene,
    Logo: jamLogo,
    Name: "Jam Doughnut",
    Description: "In this masterpiece a wild Jay, endulges in flavorful jam doughnut. Be warned, this video is most certainly going to leave you craving for some sweets.",
    Genre: "Silent Mukbang",
    Actors: "Jay",
    Year: "2022",
    Duration: "1min 5sec",
  },
  {
    Movie: "",
    Thumnbnail: hob,
    Scene: "",
    Logo: "",
    Name: "Hobbit",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: shrek,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: reven,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: imit,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: topgu,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: lucy,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: bayw,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: tomb,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: amaz,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: bigs,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: secona,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: ted,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumnbnail: amerp,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
];